import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";

import * as Colors from '../../../styles/colors'
import * as Fonts from '../../../styles/typography'

export default function Item({ icon, title, action, constract = false }) {
    return (<TouchableOpacity onPress={action}>
        <View style={styles.view}>
            <Icon name={icon} size={28} color={Colors.BLACK} />
            <Text style={styles.text}>{title}</Text>
            <Icon name={"chevron-right"} size={28} color={Colors.SECONDARY} 
            style={{
                    marginLeft: "auto"
            }}/>
        </View>
    </TouchableOpacity>)
}

const styles = StyleSheet.create({
    view: {
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 4,
        backgroundColor: Colors.SNOW,
        padding: 8,
        borderColor: Colors.SECONDARY,
        borderLeftWidth: 2,
        shadowColor: Colors.GRAY_DARK,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        borderRadius: 8,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    viewConstract: {
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 4,
        backgroundColor: Colors.SECONDARY,
        padding: 8,
        borderColor: Colors.BLACK,
        borderLeftWidth: 2,
        shadowColor: Colors.GRAY_DARK,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        borderRadius: 8,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    text: {
        marginLeft: 16,
        fontSize: Fonts.FONT_SIZE_18,
        fontWeight: "400",
        color: Colors.BLACK
    },
    textConstract: {
        marginLeft: 16,
        fontSize: Fonts.FONT_SIZE_18,
        fontWeight: "400",
        color: Colors.WHITE
    }
})